/**
 * Teams detection and auth helpers.
 * All logic is isolated here — delete this file to remove Teams support.
 */
import { app } from "@microsoft/teams-js";

let _inTeams = false;

/**
 * Call once at app startup. Resolves true if running inside Teams, false otherwise.
 * Skips the Teams SDK entirely if not in an iframe (fast path for browser users).
 */
export async function initTeams() {
  // Fast path: not in an iframe → definitely not in Teams
  if (window === window.parent && !window.navigator.userAgent.includes("TeamsMobile")) {
    return false;
  }
  try {
    await Promise.race([
      app.initialize(),
      new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), 2000)),
    ]);
    _inTeams = true;
  } catch {
    _inTeams = false;
  }
  return _inTeams;
}

export const isInTeams = () => _inTeams;

/**
 * Read Teams context (theme, locale, etc.) — only valid after initTeams() resolves true.
 */
export async function getTeamsContext() {
  if (!_inTeams) return null;
  try { return await app.getContext(); }
  catch { return null; }
}
